import { fetchSupplierList } from '#/api/srm/supplier/fetchList';

export function mapSupplierRowsToSelectOptions(rows = []) {
  return rows.map((row) => ({
    value: row.id,
    label: [row.code, row.name].filter(Boolean).join(' - ') || String(row.id),
  }));
}

/**
 * ACTIVE 供應商 select options（入庫單等）。
 * 使用 lookupQueryKey('supplierSelect')。
 */
export async function fetchSupplierSelectOptions() {
  const { data } = await fetchSupplierList({
    page: 1,
    pageSize: 200,
    keyword: '',
    sort: [],
    filters: { status: 'ACTIVE' },
  });

  return mapSupplierRowsToSelectOptions(data ?? []);
}
